import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Sunburst } from "@ant-design/plots";

const HiePlot = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch("https://gw.alipayobjects.com/os/antvdemo/assets/data/sunburst.json")
      .then((response) => response.json())
      .then((json) => setData(json))
      .catch((error) => {
        console.log("fetch data failed", error);
      });
  };
  const config = {
    data,
    height: 300,
    innerRadius: 0.3,
    interactions: [
      {
        type: "element-active",
      },
    ],
    hierarchyConfig: {
      field: "sum",
    },
    drilldown: {
      breadCrumb: {
        rootText: "起始",
      },
    },
  };

  return <Sunburst {...config} />;
};

export default HiePlot;
